<ng-container
  *ngTemplateOutlet="verifyEmailTemplate; context: verifyEmailContext"
/>
<ng-template
  #defaultVerifyEmail
  let-email="email"
  let-goBackURL="goBackURL"
  let-sendNewVerificationEmailText="sendNewVerificationEmailText"
  let-signOutText="signOutText"
  let-verifyEmailConfirmationText="verifyEmailConfirmationText"
  let-verifyEmailGoBackText="verifyEmailGoBackText"
  let-verifyEmailTitleText="verifyEmailTitleText"
>
  <mat-card class="verify-email">
    <mat-card-content fxLayout="column" fxLayoutAlign="center center">
      <mat-icon>email</mat-icon>
      <p class="title" fxLayout="column" fxLayoutAlign="center center">
        <span class="mat-subheading-2">{{ verifyEmailTitleText }}</span>
        <span class="mat-body-2">{{ email }}</span>
      </p>
      <p class="subtitle">{{ verifyEmailConfirmationText }}</p>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate" />
    </mat-card-content>
    <mat-card-actions fxLayout="column" fxLayoutAlign="center center">
      <button
        *ngIf="goBackURL"
        class="go-back-button action-button"
        mat-stroked-button
        (click)="continue()"
      >
        {{ verifyEmailGoBackText }}
      </button>
      <button
        class="send-new-mail-button action-button"
        mat-stroked-button
        (click)="sendNewVerificationEmail()"
      >
        {{ sendNewVerificationEmailText }}
      </button>
      <button
        class="sign-out-button action-button"
        color="warn"
        mat-stroked-button
        (click)="this.signOut.emit()"
      >
        {{ signOutText }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>
